import React from 'react';
import blog1 from '../images/web-tools.jpg';
import blog2 from '../images/prepare.jpg';
import blog3 from '../images/HTML-Tag.jpg';
const Blog = () => {
    return (
        <div className="container mt-5">
            <h3 className="textColor text-center"><span className="fs-2 border-bottom border-info">Some of  My Articles </span></h3>
            <div className="row mt-3 justify-content-center">
                <div className="col-md-3">
                    <div className="service shadow">
                        <img className="IMG mb-2" src={blog1} alt="books" />
                        <h5 >Front End Development tools & my experience</h5>
                        <p>To become a front end developer or full-stack developer there are key tools used by all developers. What if these tools don’t....</p>
                        <a href="https://ahmedrazon338.medium.com/all-about-know-to-front-end-developers-tools-my-experience-ae968891a3f7" target="_blank" rel="noreferrer" className="btn btn-success">Read now</a>
                    </div>
                </div>
                <div className="col-md-3">
                    <div className="service shadow-lg">
                        <img className="IMG mb-2" src={blog2} alt="books" />
                        <h5>Prepare yourself for interview</h5>
                        <p>Prepare for your next job in a front-end developer position. In this article, I’ll give some tips that would help your interview. (this is part....</p>
                        <a href="https://ahmedrazon338.medium.com/prepare-for-interview-for-web-developer-76f321f1cae" target="_blank" rel="noreferrer" className="btn btn-success">Read more</a>

                    </div>
                </div>
                <div className="col-md-3">
                    <div className="service shadow">
                        <img className="IMG mb-2" src={blog3} alt="books" />
                        <h5>Most important HTML tags list</h5>
                        <p>Do you know how many HTML tags exist? Maybe or not. Whatever, if you are a web developer, you don’t have to know all these tags...</p>
                        <a href="https://ahmedrazon338.medium.com/most-important-html-tags-listed-down-by-a-web-developer-3156c66cc21a" target="_blank" rel="noreferrer" className="btn btn-success">Read more</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Blog;